// Model de Tensão
export class Tension {
  constructor(
    public highTension: number,
    public lowTension: number
  ) { }
}
